"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.divideOverDayPeriod = exports.divideOverDayPeriodFilter = void 0;
const date_fns_1 = require("date-fns");
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
const lodash_1 = require("lodash");
const isOverDay_1 = require("../isOverDay");
const period_1 = require("../period");
const periods_1 = require("../periods");
/**
 * 日を跨ぐPeriodを分割して返すフィルター
 * @param periods
 * @returns
 */
const divideOverDayPeriodFilter = (availablePeriods) => {
    const dividedPeriodArray = (0, lodash_1.flatten)(availablePeriods.periods.map((p) => (0, exports.divideOverDayPeriod)(p)));
    return new periods_1.Periods(dividedPeriodArray);
};
exports.divideOverDayPeriodFilter = divideOverDayPeriodFilter;
/**
 * 日を跨ぐPeriodを日の境界で分割する
 * @param period
 * @returns 分割されたPeriod
 */
const divideOverDayPeriod = (period) => {
    // 跨がない場合はそのままreturn
    if (!(0, isOverDay_1.isOverDay)(period)) {
        return period;
    }
    // 中日のperiodの作成
    const periodDays = (0, date_fns_1.eachDayOfInterval)(period);
    const internalDaysPeriods = buildInternalDaysPeriods(periodDays);
    return [
        new period_1.Period(period.start, (0, endOfDay_1.default)(period.start)),
        ...internalDaysPeriods,
        new period_1.Period((0, date_fns_1.startOfDay)(period.end), period.end)
    ];
};
exports.divideOverDayPeriod = divideOverDayPeriod;
const buildInternalDaysPeriods = (periodDays) => {
    if (periodDays.length <= 2) {
        return [];
    }
    // 最初と最後の日付は除外
    const internalDays = periodDays.slice(1, periodDays.length - 1);
    return internalDays.map((d) => new period_1.Period((0, date_fns_1.startOfDay)(d), (0, endOfDay_1.default)(d)));
};
//# sourceMappingURL=divideOverDayPeriodFilter.js.map